__turbopack_context__.v({
  "chartColumn": "StateDonutChartLayout-module__XSVwZq__chartColumn",
  "chartPlate": "StateDonutChartLayout-module__XSVwZq__chartPlate",
  "decoration": "StateDonutChartLayout-module__XSVwZq__decoration",
  "legend": "StateDonutChartLayout-module__XSVwZq__legend",
  "root": "StateDonutChartLayout-module__XSVwZq__root",
});
